import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { clamp } from '../../../utils/clamp.mjs';
var number = {
  test: function test(v) {
    return typeof v === "number";
  },
  parse: parseFloat,
  transform: function transform(v) {
    return v;
  }
};
var alpha = _objectSpread(_objectSpread({}, number), {}, {
  transform: function transform(v) {
    return clamp(0, 1, v);
  }
});
var scale = _objectSpread(_objectSpread({}, number), {}, {
  default: 1
});
export { alpha, number, scale };